import FormEmployee from './form';
import { useParams } from 'react-router-dom';

const UpdateEmployeePage = ({secret}) => {
    const {fileNo, civilId, id} = useParams();
    return <FormEmployee fileNo={fileNo} civilId={civilId} id={id} secret={secret} />
}

export default UpdateEmployeePage;